import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import App from './App';
import * as Sentry from '@sentry/react';
import { Amplify } from 'aws-amplify';
import { configuration } from 'awsconfig';
Amplify.configure(configuration);

import './i18n';

const ENVIRONMENTS: { [key: string]: string } = {
  localhost: 'dev',
  'dev.qbilling.com': 'dev',
  'www.qbilling.ca': 'prod',
};

const getEnvironment = (): string => {
  const hostname = window.location.hostname;
  return ENVIRONMENTS[hostname] || 'dev';
};
const VITE_PROJECT_VERSION = import.meta.env.VITE_PROJECT_VERSION || 'unknown';

Sentry.init({
  dsn: 'https://dc98aebdffdfd4e6a03cc2dc0f05c49f@o1148284.ingest.us.sentry.io/4507075093725185',
  integrations: [
    Sentry.replayIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.zodErrorsIntegration(),
    Sentry.httpContextIntegration(),
  ],
  tracesSampleRate: import.meta.env.DEV ? 0 : 1,
  environment: getEnvironment(),
  replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: VITE_PROJECT_VERSION,
});

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
